import { ConfigFacadeService } from '@core/services/config/config-facade.service';
import { ApiFacadeService } from '@app/services/api-facade.service';
import { IPartner } from '@modules/admin-panel/domain/models/admin';
import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root',
})
export class PartnersService {
	private _partners: BehaviorSubject<IPartner[]> = new BehaviorSubject<IPartner[]>(null);

	constructor(private apiFacade: ApiFacadeService, private config: ConfigFacadeService) {}

	public getPartners(): Observable<IPartner[]> {
		if (this._partners.value) {
			return this._partners.asObservable();
		}
		const url = 'admin/partners';
		return this.apiFacade.get<{ resellers: IPartner[] }>(url).pipe(
			map((response) => {
				this._partners.next(response.resellers);
				return response.resellers;
			}),
		);
	}

	public get isAllowedToSelectPartner(): boolean {
		return !this.config.partnerId; // there is no partnerId in the config only for Zesty prod tenant
	}
}
